import imglogo from '../../../assets/img/logo_t4i.png'
import bgAuthenticate from '../../../assets/img/bg-authenticate.png'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm } from './hooks/useForm'
import '../login.css'
import './signup.css'
import classNames from 'classnames'
import { CustomModal } from '../../../components/CustomModal/CustomModal'
import { useAuthentication } from '../../../customHooks/useAuthentication'
import { blockInvalidChar } from '../../../context/constants'

const initialForm = {
  code: '',
}

const validationsForm = (form) => {
  const errors = {}
  if (!(form.code.trim().length > 0)) {
    errors.code = 'code is invalid'
  }
  return errors
}

function ValidationCode() {
  const history = useHistory()
  const { getInfoFromLocalStorage, saveItemInLocalStorage } = useAuthentication()
  const [userInfo, setUserInfo] = useState(null)

  useEffect(() => {
    const stored = getInfoFromLocalStorage('item_validation_info')
    if (stored && Object.keys(stored).length > 0) {
      setUserInfo(stored)
      return
    }
    const params = new URLSearchParams(window.location.search)
    const email = params.get('email')
    if (email) {
      const next = { email, phoneNumber: params.get('phone') || '' }
      saveItemInLocalStorage('item_validation_info', next)
      setUserInfo(next)
      return
    }
    history.replace('/sign_up')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { form, errors, handleChange, handleBlur, handleSubmit, showSuccessButton, showModal, setShowModal, customTittleText, customMessageModal, cancelButtonText, sucessButtonText, isLoading, manageResponseMessage } =
    useForm(initialForm, validationsForm, 'ValidateCode')

  if (!userInfo) return null

  return (
    <>
      <div className="login">
        <div className="hero-split">
          <img alt="Tech4Inventory Warehouse" className="hero-image" src={bgAuthenticate} />
        </div>
        <div className="form-split">
          <div className="form-container form-container__signup">
            <div className="form-container_top">
              <img src={imglogo} alt="Tech4Inventory Logo" className="logo" />
              <h1 className="title-app">Tech4Inventory</h1>
              <span className="subtitle-app">Enter your validation code</span>
              <div className="information-content__signup">
                Code sent to <strong>{userInfo.email}</strong>
              </div>
            </div>
            <form className="form" onSubmit={(e) => e.preventDefault()}>
              <div className="theinputs">
                <div className="input-group validation-input-group">
                  <label className="label" htmlFor="code">
                    Validation code
                  </label>
                  <div className="relative-input-wrapper">
                    <span className="input-icon material-symbols-outlined">pin</span>
                    <input
                      type="text"
                      className={classNames('input', 'input-with-icon', 'validation-code-input', { 'is-invalid': errors.code || manageResponseMessage.message.length > 0 })}
                      name="code"
                      id="code"
                      value={form.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="Enter code"
                      title="Enter your validation code"
                      required
                      onKeyDown={blockInvalidChar}
                    />
                  </div>
                  {errors.code && (
                    <p className="message_error">
                      <span>{errors.code}</span>
                    </p>
                  )}
                  {manageResponseMessage.message.length > 0 && !manageResponseMessage.status && (
                    <p className="message_error">
                      <span>{manageResponseMessage.message}</span>
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  className="primary-button"
                  disabled={isLoading}
                  onClick={(e) =>
                    handleSubmit(e, 'validate_code', false, {
                      email: userInfo.email,
                    })
                  }
                >
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    'Validate code'
                  )}
                </button>
                <button
                  type="button"
                  className="secondary-button"
                  disabled={isLoading}
                  onClick={(e) =>
                    handleSubmit(e, 'resend_code', true, {
                      email: userInfo.email,
                    })
                  }
                >
                  Re-send code
                </button>
              </div>
            </form>
            {manageResponseMessage.status && manageResponseMessage.message.length > 0 && manageResponseMessage.showRedirectButton && (
              <div className="validation-success-message">
                <p>
                  {manageResponseMessage.message}{' '}
                  <button type="button" className="validation-success-link" onClick={() => history.push('/')}>
                    Go to login
                  </button>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <CustomModal
        show={showModal}
        customTittleText={customTittleText}
        customMessageModal={customMessageModal}
        onHandleClose={() => setShowModal(false)}
        onHandleSuccess={() => {}}
        isLoading={false}
        showSuccessButton={showSuccessButton}
        actionsFooterStyle={true}
        cancelText={cancelButtonText}
        successText={sucessButtonText}
      />
    </>
  )
}

export { ValidationCode }
export default ValidationCode
